module.exports = __webpack_public_path__ + "img/android_3.be35fdda.jpg";